<template>
  <div class="table-container fade-in">
    <table v-if="produtos.length > 0">
      <thead>
      <tr>
        <th>Produto</th>
        <th>Preço</th>
        <th>Consumo</th>
        <th>Status</th>
        <th class="actions-cell">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="prod in produtos" :key="prod.id">
        <td>
          <div class="prod-name">{{ prod.nome }}</div>
          <div class="prod-sub">{{ prod.unidade }}</div>
        </td>
        <td class="price-cell">R$ {{ Number(prod.preco).toFixed(2).replace('.', ',') }}</td>
        <td>
           <span v-if="prod.inventario_id" class="resource-tag">
            -{{ prod.unidades_consumidas }} {{ getNomeRecurso(prod.inventario_id) }}
          </span>
          <span v-else class="sub-text">-</span>
        </td>
        <td>
          <span :class="['status-badge', prod.disponivel ? 'approved' : 'rejected']">
            {{ prod.disponivel ? 'Ativo' : 'Inativo' }}
          </span>
        </td>
        <td class="actions-cell">
          <button @click="$emit('upload', prod)" class="action-btn photos" title="Fotos">
            <span class="material-icons-outlined">photo_camera</span>
          </button>
          <button @click="$emit('edit', prod)" class="action-btn edit" title="Editar">
            <span class="material-icons-outlined">edit</span>
          </button>
          <button @click="$emit('delete', prod)" class="action-btn delete" title="Excluir">
            <span class="material-icons-outlined">delete</span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-else class="empty-state">Nenhum produto cadastrado.</div>
  </div>
</template>

<script>
export default {
  name: 'TabelaProdutos',
  props: {
    produtos: Array,
    inventario: Array
  },
  methods: {
    getNomeRecurso(id) {
      const item = this.inventario.find(i => i.id === id);
      return item ? item.nome_recurso : `(ID: ${id})`;
    }
  }
};
</script>

<style scoped src="@/assets/admin-styles.css"></style>
<style scoped>
.prod-name { font-weight: bold; font-size: 1rem; display: block; }
.prod-sub { font-size: 0.8rem; color: var(--text-secondary); }
.resource-tag { background-color: rgba(33, 150, 243, 0.1); color: #2196F3; padding: 4px 8px; border-radius: 4px; font-size: 0.8rem; font-weight: 600; display: inline-block; }
.action-btn.delete { border-color: #f44336; color: #f44336; }
.action-btn.delete:hover { background-color: rgba(244, 67, 54, 0.1); }
.action-btn.photos { border-color: #9C27B0; color: #9C27B0; }
.action-btn.photos:hover { background-color: rgba(156, 39, 176, 0.1); }
.fade-in { animation: fadeIn 0.3s ease; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
</style>